import { Flex, Popover, Text, UnstyledButton } from "@mantine/core";

export type BillingDetailsToolTipProps = {
    title: string;
    body: string;
};

export function BillingDetailsToolTip({ body, title }: BillingDetailsToolTipProps) {
    return (
        <Flex c="dark.1" pb={0} pt={6}>
            <Popover width={260}>
                <Popover.Target>
                    <UnstyledButton td="underline" fz="sm" c="dark.1">
                        {title}
                    </UnstyledButton>
                </Popover.Target>
                <Popover.Dropdown>
                    <Text fz="sm" c="dark.1">
                        {body}
                    </Text>
                </Popover.Dropdown>
            </Popover>
        </Flex>
    );
}
